export const getEmployeeSelector = (state) =>
  state.employeesReducer?.selectedEmployee;
export const getEmployeeIdSelector = (state) =>
  state.employeesReducer.selectedEmployee.id;
